import { DialogContent, Modal } from '@mui/material'
import { useCallback, useContext, useEffect, useMemo, useState } from 'react'

import ModalLayout from '@/components/common/ModalLayout'
import useNemoWallet from '@/hooks/use-nemo-wallet'
import useTrans from '@/hooks/useTrans'

import { WrappedTokensFlowContext } from '../context'
import FlowConnectWallet from '../FlowConnectWallet'
import FlowDepositCode from '../FlowDepositCode'
import FLowDepositConfirm from '../FlowDepositConfirm'
import FlowWrappingInfo from '../FlowWrappingInfo'
import { FlowStep, STEP_CONFIRM, STEP_CONNECT_WALLET, STEP_QR_CODE, STEP_WRAPPING_INFO } from './utils'

const classesDialog = { root: 'outline-none p-0 h-full' }
const Container = () => {
  const trans = useTrans()
  const { publicKey } = useNemoWallet()
  const [flowStep, setFlowStep] = useState<FlowStep>(!publicKey ? STEP_CONNECT_WALLET : STEP_QR_CODE)
  const { selectedToken, setSelectedToken } = useContext(WrappedTokensFlowContext)

  const isOpenModal = Boolean(selectedToken)

  useEffect(() => {
    if (!isOpenModal) { // Reset data
      setFlowStep(!publicKey ? STEP_CONNECT_WALLET : STEP_QR_CODE)
      setSelectedToken(null)
    }
  }, [publicKey, isOpenModal, setSelectedToken])

  const modalTitle = useMemo(() => {
    if (!selectedToken) return ''
    const displaySymbol = selectedToken.displaySymbol

    return {
      [STEP_CONNECT_WALLET]: trans.wrapped_token.title.you_have_token(displaySymbol),
      [STEP_QR_CODE]: trans.wrapped_token.title.step_to_deposit(displaySymbol),
      [STEP_CONFIRM]: trans.wrapped_token.title.wait_to_confirm,
      [STEP_WRAPPING_INFO]: trans.wrapped_token.title.wrapping_token(displaySymbol),
    }[flowStep]
  }, [trans, selectedToken, flowStep])

  const handleCloseModal = useCallback(() => {
    setSelectedToken(null)
  }, [setSelectedToken])

  const handleGoToConfirm = useCallback(() => {
    setFlowStep(STEP_CONFIRM)
  }, [])

  const handleGoToStepInfo = useCallback(() => {
    setFlowStep(STEP_WRAPPING_INFO)
  }, [])

  const hasBottomCloseBtn = [STEP_QR_CODE, STEP_CONFIRM].includes(flowStep)

  return (
    <Modal open={isOpenModal} onClose={handleCloseModal}>
      <DialogContent classes={classesDialog}>
        <ModalLayout
          title={modalTitle}
          onClose={handleCloseModal}
          isDisplayBtnClose={hasBottomCloseBtn}
          footer={trans.common.powered_by_remitano}
        >
          {flowStep === STEP_CONNECT_WALLET && (
            <FlowConnectWallet onClick={handleCloseModal} />
          )}
          {flowStep === STEP_QR_CODE && (
            <FlowDepositCode onNext={handleGoToConfirm} />
          )}
          {flowStep === STEP_CONFIRM && (
            <FLowDepositConfirm onNext={handleGoToStepInfo} />
          )}
          {flowStep === STEP_WRAPPING_INFO && (
            <FlowWrappingInfo onClose={handleCloseModal} />
          )}
        </ModalLayout>
      </DialogContent>
    </Modal>
  )
}

export default Container
